import React, { useContext, useState } from "react";
import "./Login.css";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCircleArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import Border_btn from "../Common_Component/Border_btn/Border_btn";
import Star_Lottie from "../Common_Component/Star_Lottie/Star_Lottie";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { LoginPost } from "../../utils/apis/Login";
import { Context } from "../../utils/context";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { CookieName } from "../../utils/common";
function Login() {
  const { setSignin, setUsertype, setisAllow } = useContext(Context);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setError,
  } = useForm();

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      const result = await LoginPost(data);

      console.log(result, "result");

      if (result?.data?.success) {
        setSignin(result?.data?.success);
        setUsertype(result?.data?.data?.role);
        setisAllow(result?.data?.data?.permissions);

        Cookies.set(CookieName, result?.data?.data?.token, {
          expires: 365,
        });

        navigate("/dashboard");
      } else {
        setError("password", {
          message: result?.errors,
        });
      }
      return;
    } catch (error) {
      console.error("Login Error:", error);

      if (error.response) {
        const errors = error.response.data?.errors;

        if (errors) {
          Object.keys(errors).forEach((field) => {
            setError(field, {
              type: "server",
              message: errors[field],
            });
          });
        } else {
          setError("password", {
            type: "server",
            message: error.response.data?.message || "Something went wrong.",
          });
        }
      } else {
        setError("password", {
          type: "server",
          message: error.message,
        });
      }
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const { signin, usertype } = useContext(Context);

  if (signin) {
    navigate("/dashboard");
  } else {
    return (
      <>
        <section className="Login">
          <div className="container container-holder">
            <div className="row main-content-holder  ">
              <div className="col-xxl-4 col-xl-4 col-lg-5 col-md-6 col-sm-12">
                <div className="main-Form-holder">
                  <div className="img-holder">
                    <img
                      className="logo-img"
                      src={process.env.PUBLIC_URL + " /just_booking_logo.png"}
                      alt="logo-img"
                    />
                  </div>
                  <div className="form-holder ">
                    <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className="font-use">Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter Email"
                          className={classNames("", {
                            "is-invalid": errors?.email,
                          })}
                          {...register("email", {
                            required: "Email is required",
                          })}
                        />
                        {errors.email && (
                          <span className="text-danger">
                            {errors.email.message}
                          </span>
                        )}
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="formBasicPassword">
                        <Form.Label className="font-use">Password</Form.Label>

                        <div className="position-relative">
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            className={classNames({
                              "is-invalid": errors?.password,
                              "no-error-icon": errors?.password,
                            })}
                            {...register("password", {
                              required: "Password is required",
                            })}
                          />

                          <span
                            className="password-toggle"
                            onClick={togglePasswordVisibility}>
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>

                        {errors.password && (
                          <span className="text-danger">
                            {errors.password.message}
                          </span>
                        )}
                      </Form.Group>

                      <section className="Border_btn">
                        <Button
                          className="sign-up-btn font-use"
                          type="button"
                          onClick={handleSubmit(onSubmit)}>
                          Login
                          <span>
                            <FontAwesomeIcon icon={faCircleArrowRight} />
                          </span>
                        </Button>
                      </section>
                      {/* <Border_btn btnText={"Sign Up"} baseLink={"/dashboard"} /> */}
                    </Form>
                  </div>
                </div>
              </div>

              {/* <div className="col-lg-4 col-md-5"> */}
              {/* <div className="casino-img-holder"> */}
              {/* <img
                    className="casino-img"
                    src={process.env.PUBLIC_URL + "/Login/casino-wheel.png"}
                    alt="casino-img"
                  /> */}
              {/* Place multiple instances of Star_Lottie here with different classes */}
              {/* <div className="star-lottie top-left">
                    <Star_Lottie />
                  </div>
                  <div className="star-lottie bottom-center">
                    <Star_Lottie />
                  </div>
                  <div className="star-lottie top-right">
                    <Star_Lottie />
                  </div> */}
              {/* </div> */}
              {/* </div> */}
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Login;
